import './_sticky-container.scss';

window.app.stickyContainer = window.app.stickyContainer || {};
window.app.stickyContainer.Index = async function(root) {
  const StickyContainer = (await import(/* webpackChunkName: "modules" */ './sticky-container')).default;

  const stickyContainer = new StickyContainer(root);
  return stickyContainer.init();
};